<div class="wager-confirm-dialog tw-flex tw-flex-col tw-w-full">

  <!-- Header -->
  <div
    class="
      modal-header
      tw-flex
      tw-items-center
      tw-justify-between
      tw-bg-[#1B478A]
      tw-text-[#FFFFFF]
      tw-rounded-t-[12px]
      tw-px-[16px]
      tw-py-[14px]
    "
  >
    <!-- Callers pass English copy, which the pipe resolves by wording -->
    <p class="modal-title tw-text-[18px] tw-font-bold tw-mb-0 tw-uppercase">
      {{ data.title | translate }}
    </p>
    <button
      type="button"
      mat-icon-button
      (click)="close()"
      [attr.aria-label]="'generic.close' | translate: 'Close'"
      class="close-icon !tw-text-white"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Body -->
  <div class="modal-body tw-bg-white tw-px-[20px] tw-py-[18px] tw-text-center">

    <!-- Bulk actions show a plain confirm message; single ticket shows details -->
    @if (data.message) {
      <p
        class="
          confirm-message
          tw-text-[#0E2543]
          tw-text-[16px]
          tw-font-semibold
          tw-break-words
        "
      >
        {{ data.message }}
      </p>
    } @else {
      <p
        class="
          event-name
          tw-text-[#0E2543]
          tw-text-[18px]
          tw-font-bold
          tw-uppercase
          tw-mb-[6px]
          tw-break-words
        "
      >
        {{ data.eventName }}
      </p>

      <p
        class="
          race-id
          tw-text-[#0E2543]
          tw-text-[16px]
          tw-font-semibold
          tw-uppercase
          tw-mb-[14px]
        "
      >
        {{ 'generic.race' | translate: 'Race' }} {{ data.raceId }}
      </p>

      <div
        class="
          bet-summary
          tw-bg-[#F1F5FB]
          tw-rounded-[8px]
          tw-px-[12px]
          tw-py-[10px]
          tw-text-[#0E2543]
          tw-text-[15px]
          tw-font-bold
          tw-flex
          tw-flex-wrap
          tw-justify-center
          tw-items-center
          tw-gap-x-[6px]
          tw-gap-y-[2px]
        "
      >
        <span class="bet-amount tw-text-[#036E23]">${{ data.baseAmount | number:'1.2-2' }}</span>
        @if (data.poolId) {
          <span class="bet-pool tw-uppercase">{{ data.poolId }}</span>
        }
        <!-- Abbreviation only: placeholder modifiers such as 'None' resolve to
             blank, matching how bet rows are written elsewhere -->
        @if (data.modifierAbbr) {
          <span class="bet-modifier tw-uppercase">{{ data.modifierAbbr }}</span>
        }
        @if (data.runners) {
          <span class="bet-runners tw-text-[#1B478A]">{{ 'ui.wager.on.runners' | translate: 'on' }} {{ data.runners }}</span>
        }
      </div>

      @if (data.totalAmount && data.totalAmount > 0) {
        <p class="total-cost tw-mt-[14px] tw-text-[14px] tw-font-bold tw-text-[#0E2543]">
          {{ 'ui.generic.total.cost' | translate: 'Total Cost:' }}
          <span class="tw-text-[#036E23]">${{ data.totalAmount | number:'1.2-2' }}</span>
        </p>
      }
    }
  </div>

  <!-- Footer / actions -->
  <div
    class="
      modal-actions
      tw-flex
      tw-justify-between
      tw-gap-[12px]
      tw-bg-white
      tw-rounded-b-[12px]
      tw-px-[20px]
      tw-pb-[18px]
    "
  >
    <button
      type="button"
      mat-stroked-button
      color="warn"
      class="cancel-btn !tw-flex-1 !tw-rounded-full tw-uppercase"
      (click)="close()"
    >
      {{ 'generic.close' | translate: 'Close' }}
    </button>
    <button
      type="button"
      mat-flat-button
      color="primary"
      class="submit-btn !tw-flex-1 !tw-rounded-full tw-uppercase"
      (click)="submit()"
    >
      @if (data.confirmButtonLabel) {
        {{ data.confirmButtonLabel | translate }}
      } @else if (data.betType === 'bet-now' || data.betType === 'submit-saved-bet') {
        {{ 'generic.submit' | translate: 'Submit' }}
      } @else if (data.betType === 'remove-saved-bet') {
        {{ 'generic.remove' | translate: 'Remove' }}
      } @else if (data.betType === 'cancel-bet') {
        {{ 'generic.cancel' | translate: 'Cancel' }}
      } @else {
        {{ 'generic.save' | translate: 'Save' }}
      }
    </button>
  </div>

</div>
